import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SimpleMediaQuery from './SimpleMediaQuery';
import ClientProvider from './client';
export default createDemo(import.meta.url, SimpleMediaQuery, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/use-media-query/demos/simple-media-query/SimpleMediaQuery.tsx",
    "fileName": "SimpleMediaQuery.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import useMediaQuery from '@mui/material/useMediaQuery';\n\nexport default function SimpleMediaQuery() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 0,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const matches = useMediaQuery('(min-width:600px)');\n\n  return <span>{`(min-width:600px) matches: ${matches}`}</span>;\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 7,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import useMediaQuery from '@mui/material/useMediaQuery';\n\nexport default function SimpleMediaQuery() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 0,
          "dataFrameFocusTarget": ""
        },
        "  const matches = useMediaQuery('(min-width:600px)');\n\n  return <span>{`(min-width:600px) matches: ${matches}`}</span>;\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 0,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 4
            },
            [
              "  ",
              [
                "span",
                "pl-k",
                "const"
              ],
              " ",
              [
                "span",
                "pl-c1",
                "matches"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              " ",
              [
                "span",
                "pl-en",
                "useMediaQuery"
              ],
              "(",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "(min-width:600px)",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ");"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 5
            },
            "\n"
          ],
          [
            "span",
            "line",
            {
              "dataLn": 6
            },
            [
              "  ",
              [
                "span",
                "pl-k",
                "return"
              ],
              " <",
              [
                "span",
                "pl-ent",
                "span"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ],
                  "(min-width:600px) matches: ",
                  [
                    "span",
                    "di-te",
                    [
                      [
                        "span",
                        "di-td",
                        "${"
                      ],
                      [
                        "span",
                        "pl-smi",
                        "matches"
                      ],
                      [
                        "span",
                        "di-td",
                        "}"
                      ]
                    ]
                  ],
                  [
                    "span",
                    "pl-pds",
                    "`"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-ent",
                "span"
              ],
              ">;"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 7,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/useMediaQuery"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
